import * as React from 'react'
import {
    OfferForm,
} from './PrismaRequestDetailsState'
import Dialog from 'material-ui/Dialog'
import { PrismaRequestDetailsAction } from './PrismaRequestDetailsActions'
import Button from 'material-ui-next/Button/Button'

export function PrismaRequestSubmitOfferModal({state, dispatch}: {
    state: OfferForm,
    dispatch: (action: PrismaRequestDetailsAction) => void,
}) {
    return (
        <div>
            <Dialog
                title="Angebot abgeben"
                modal={true}
                open={state.isPriceSubmitModalOpen}
            >
                <div style={{width: '100%', boxSizing: 'border-box', padding: '8px'}}>
                    Möchen Sie wirklich ein Angebot über {state.priceInput.price} € abgeben?<br/>
                    <br/>
                </div>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                    <Button
                        color="secondary"
                        raised={true}
                        onClick={
                            () => dispatch(
                                {
                                    type: 'ClosePriceSubmitModal',
                                    offerType: state.prismaRequestOffer.type,
                                },
                            )
                        }
                    >
                        Abbrechen
                    </Button>
                    <Button
                        color="primary"
                        raised={true}
                        onClick={
                            () => {
                                dispatch(
                                    {
                                        type: 'PriceSubmit',
                                        offerType: state.prismaRequestOffer.type
                                    }
                                )
                            }
                        }
                    >
                        Angebot abgeben
                    </Button>
                </div>
            </Dialog>
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/PrismaRequestDetails/PrismaRequestSubmitOfferModal.tsx